export default {
  BAndRText: "本とレビュー",
  Srchbook: "本で検索",
  offlisugg: "Ofellioのおすすめ",
  recentlyRated: "最近評価した",

  // ReviewPage
  rewbtn1: "読みたい",
  rewbtn2: "レビューを書く",
  rewbtn3: "Book Duoで使う",
  rateBook: "この本を評価する",
  buyon: "購入先",
  Read: "読んだ",
  reviewtext: "レビュー",
  ratingtext: "あなたの評価",
  readon: "読み方",
  book: "本",
  ebook: "電子書籍",
  audiobook: "オーディオブック",
  revTitle: "レビューのタイトル",
  submitbtn: "送信",

  // Book Duo Page
  yourbd: "あなたのBook Duo",
  serchbook: "本を検索",
  DidText: "本が見つかりませんか？詳細を入力してください！",
  city: "都市",
  type: "タイプ",
  lookigfr: "募集内容",
  male: "男性",
  female: "女性",
  idk: "どちらでも",
  agerg: "年齢層",
  language: "言語",
  detil: "詳細",
  optnal: "任意",
  lookiginsp: "いくつかのヒント",
  suggbokduo: "Book Duoにおすすめの本",
  seemoresugg: "他のおすすめを見る",
  bokcvr: "表紙",
  title: "タイトル",
  writer: "著者",
  genre: "ジャンル",
  upload: "アップロード",
  add: "追加",
  online: "オンライン",
  onlink: "ビデオ通話リンクを追加（Teams・Zoom・Google Meetなど）",
  noBookSelected: "本が選択されていません",
  loading: "読み込み中...",
  noResultsFound: "結果が見つかりません",
  meetingLink: "ミーティングリンク",
  noLimit: "制限なし",
  languageTooltip: "これは、Book Duo中に参加者が話す言語です。",
  languageTooltipBookClub: "これは、Book Club中に参加者が話す言語です。",
  updating: "更新中...",
  publishing: "公開中...",
  update: "更新",
  noBooksFound: "この1:1の提案の下に本が見つかりませんでした。",
  wellDone: "よくできました！",
  bookDuoLive: "あなたのBook Duoがライブになりました。",
  willInformInterest: "誰かが興味を示したらお知らせします！",
  seeOn: "見る",
  map: "地図",

  // Book Club Page
  when: "日時",
  time: "時間",
  age: "年齢",
  publsbtn: "公開する",
  day: "日",
  month: "月",
  year: "年",
  hour: "時",
  min: "分",
  max: "最大",
  selectTime: "時間を選択",
  selectLanguage: "言語を選択",
  selectType: "タイプを選択",
  inPerson: "対面",
  attendees: "参加者",
  eventDetails: "イベント詳細",

  // Silent Reading Page
  where: "場所",
  venue: "会場",
  address: "住所",

  // BookAnd Review page Event
  welc: "ようこそ",
  memb: "メンバー",
  exploreText: "近くやオンラインで開催されているイベントを探して参加し、自分のイベントも作成しましょう。",
  sbybooks: "タイトルで検索",
  month: "月",
  sortby: "並び替え",
  cbduo: "Book Duoを作成",
  smoreevent: "他のイベントを見る",
  dowant: "自分のイベントを作りますか？",
  ledAmbsdr: "ブッククラブとサイレントリーディングはAmbassadorが主催します。",
  bAnAmbsdor: "Ambassadorになる",
  leadText: "主催したり、気になるイベントに参加したりしましょう。",
  evtnear: "近くで参加できるイベント。",
  BookDuoFirstText: `心の通うつながりを探していますか？Book Duoがぴったりです！`,
  BookDuoSecondText: `本を選び、つながりたい相手の性別と年齢層を決めれば準備完了。誰かが興味を示したらチャットで連絡を取り、1対1のイベント詳細を決めましょう。`,

  BookClubFirstText: `地元のカフェやバーなどの心地よい場所、またはオンラインで開かれるブッククラブに参加してみましょう。`,
  BookClubSecondText: `各Ofellioブッククラブは最大8名まで、年齢層ごとに分けてより快適で楽しい体験を提供します。Ambassadorが進行役を務め、活気のある包容的な雰囲気を作ります。`,

  BookSilentFirstText: `落ち着いた空間で行われるサイレントリーディングでは、最大10名の読者が静かに読書を楽しめます。`,
  BookSilentSecondText: `Ambassadorがリードし、好きな本を持ち寄って静かに読み、希望すればリラックスした雰囲気の中で他の読者と交流できます。`,

  DuoBtnText: `Book Duoを作成`,
  ClubBtnText: `ブッククラブを作成`,
  SilentBtnText: `サイレントリーディングを作成`,
  bookDuoTitle: "Book Duo",
  bookClubTitle: "ブッククラブ",
  bookSilentTitle: "Silent Reading",

  // BOOK_CLUB DUO SILENTREADING
  yownbook: "自分の本",
  resetFilters: "フィルターをリセット",
  resetAll: "すべてリセット",
  applyFilters: "フィルターを適用",
  filters: "フィルター",
  full: "満員",
  booksCover: "本の表紙",
  writerLabel: "著者",
  genreLabel: "ジャンル",
  aboutTheBookLabel: "本について",
  addButton: "追加",
  booked: "予約済み",
  open: "募集",
  buyon: "購入先",
  gender: "性別",
  locatedin: "場所",
  aboutbook: `あらすじ`,
  readmore: `さらに表示`,
  readless: `折りたたむ`,
  details: "詳細",
  totalspot: "定員",
  spotleft: "残り枠",
  join: "参加する",
  share: "共有",
  cregistration: "登録を完了",
  registrationmsg: "あなたのメールアドレスはAmbassadorと共有されます。",
  welldone: "お疲れさま！",
  attending: "参加予定: ",
  attendmsg: "このイベントはダッシュボードに表示され、Ambassadorとチャットできます。",
  thankyou: "ありがとうございます！",
  thankmsg: "主催者にあなたの参加希望が伝わりました。詳細の調整についてメッセージが届くかもしれません。",

  // CHAT PAGE
  msgtext: "メッセージ",
  vprofile: "プロフィールを見る",
  mute: "ミュート",
  block: "ブロック",
  unblock: "ブロック解除",
  report: "報告する",

  // Setting Page
  pprofile: "プロフィール設定",
  accnotifi: "通知",
  uploadp: "写真をアップロード",
  name: "名前",
  surname: "姓",
  dob: "生年月日",
  aboutme: "自己紹介",
  country: "国",
  favgenre: "お気に入りジャンル",
  asmedia: "SNSアカウントを追加",
  savechgbtn: "変更を保存",

  cypass: "パスワードを変更",
  cypasstext: "パスワードを変更すると、他の端末からは自動的にログアウトされます。",
  cpass: "パスワードを変更",
  cyemail: "メールアドレスを変更",
  cyemailtext: "メールを変更すると他のセッションからログアウトされます。",
  cemail: "メールを変更",
  notifi: "通知",
  emailmeab: "次の情報を受け取る",
  lastesttext: "最新のトレンド本",
  upcomtext: "来月発売予定の新刊",
  baevent: "あなたが好きそうな本・著者・イベント",
  newoff: "Ofellioの新機能",

  curnpass: "現在のパスワード",
  newpass: "新しいパスワード",
  cnewpass: "新しいパスワードを確認",
  curnemail: "現在のメール",
  newemail: "新しいメール",
  cnewemail: "新しいメールを確認",
  delyacc: "アカウントを削除",
  sorrytext: "ご利用いただけなくなるのは残念です。",
  suretext: "本当に削除しますか？",
  decitext: "再度Ofellioを利用する場合は、新しいアカウントを作成する必要があります。",
  pass: "パスワード",

  // menu
  jan: "1月",
  feb: "2月",
  mar: "3月",
  apr: "4月",
  may: "5月",
  jun: "6月",
  jul: "7月",
  aug: "8月",
  sep: "9月",
  oct: "10月",
  nov: "11月",
  dec: "12月",
  // Month abbreviations
  monthAbbrJan: "1月",
  monthAbbrFeb: "2月",
  monthAbbrMar: "3月",
  monthAbbrApr: "4月",
  monthAbbrMay: "5月",
  monthAbbrJun: "6月",
  monthAbbrJul: "7月",
  monthAbbrAug: "8月",
  monthAbbrSep: "9月",
  monthAbbrOct: "10月",
  monthAbbrNov: "11月",
  monthAbbrDec: "12月",
  cri: "ミステリー",
  fic: "フィクション",
  grpnvl: "グラフィックノベル・漫画",
  yng: "ヤングアダルト・LGBTQ+",
  nonfic: "ノンフィクション",
  scifan: "SF・ファンタジー",
  others: "その他",
  morerec: "新しい順",
  lessrec: "古い順",

  // Header/Profile
  setg: "設定",
  logout: "ログアウト",

  // dashbords pages
  editprf: "プロフィールを編集",
  cbduo: "Book Duoを作成",
  joining: "参加中",
  bandrew: "本とレビュー",
  upcomclub: "今後のブッククラブ",
  upcomduo: "今後のBook Duo",
  upcomsil: "今後のサイレントリーディング",
  allpst: "過去のイベント",
  edit: "編集",
  going: "参加する",
  ngoing: "不参加",
  cancel: "キャンセル",

  level: "レベル",
  cbclub: "ブッククラブを作成",
  cbsil: "サイレントリーディングを作成",
  loyprog: "ロイヤルティプログラム",
  mang: "管理",
  attlist: "参加者リスト",
  event: "イベントを編集",

  chatgroup: "グループとチャット",
  chatambas: "Ambassadorとチャット",

  bookshelv: "の本棚",
  reviews: "レビュー",

  // Leading Page
  ambassador: "Ambassador",
  member: "メンバー",
  level1: "レベル1",
  level2: "レベル2",
  level3: "レベル3",
  level4: "レベル4",
  toLevel: "へ",
  highestLevel: "🎉 最高レベルに到達しました！",
  editProfile: "プロフィールを編集",
  createBookClub: "ブッククラブを作成",
  createSilentReading: "サイレントリーディングを作成",
  createBookDuo: "ブックデュオを作成",
  createEvent: "+ イベントを作成",
  attendeesList: "参加者リスト",
  wantToRead: "読みたい",
  remove: "削除",
  tbd: "未定",
  full: "満員",
  yourOwnBook: "あなた自身の本",
  ageLabel: "年齢：",
  manage: "管理",
  cancelRSVP: "RSVPをキャンセル",
  imLeading: "主催中",
  imJoining: "参加中",
  booksAndReviews: "本とレビュー",
  loyaltyProgram: "ロイヤリティプログラム",
  upcomingBookClubs: "今後のブッククラブ",
  upcomingSilentReadings: "今後のサイレントリーディング",
  upcomingBookDuos: "今後のブックデュオ",
  noEventsToShow: "表示するイベントがありません。",
  wantToReadLower: "読みたい",
  readLower: "読んだ",
  reviewsLower: "レビュー",
  noRatedBooks: "まだ本を評価していません。",
  giftsDiscounts: "読書のギフトと割引",
  loyaltyDescription: "読めば読むほど、もっと獲得できます！レベルアップしながら割引と特典をお楽しみください。",
  starterReader: "初心者リーダー",
  starterReaderDesc: "OfellioAmbassadorとしての旅を始め、最初の読書体験を主導し始めましょう。",
  starterReaderReward: "早期の認識と将来のAmbassador特典へのアクセス。",
  communityBuilder: "コミュニティビルダー",
  communityBuilderDesc: "読者を接続し続け、コミュニティ内で魅力的な本のイベントを作成してください。",
  communityBuilderReward: "新機能と独占的な更新への優先アクセス。",
  proHost: "プロホスト",
  proHostDesc: "意味のある読書の瞬間を形作り、イベントを通じて他の人にインスピレーションを与えています。",
  proHostReward: "今後のOfellioイニシアチブと特別なサプライズへの招待。",
  legend: "伝説",
  legendDesc: "世界中の読者にインスピレーションを与え続けてください—あなたのリーダーシップがOfellioコミュニティを形作ります。",
  legendReward: "独占的な認識と進化する特典を解除してください。",
  attendees: "参加者",
  noAttendeesYet: "まだ参加者はいません。",
  chatWithGroup: "グループとチャット",
  cancelEvent: "イベントをキャンセル",
  cancelRSVPConfirm: "RSVPをキャンセルしてもよろしいですか？",
  cancelEventConfirm: "このイベントをキャンセルしてもよろしいですか？",
  cancelRSVPEmail: "キャンセルメールがAmbassadorに送信されます。",
  cancelEventEmail: "キャンセルメールが現在の参加者に送信されます。",

  // How It Works Section
  howOfellioWorks: "Ofellioの使い方",
  howItWorksDesc: "本を通じて新しいつながり方を発見しましょう — 1対1でも、グループでも、静かなサイレントリーディングセッションでも。",
  bookDuoTitle: "ブックデュオ",
  bookDuoDesc: "個人的なつながりを求めていますか？本を選び、パートナーの年齢と性別の好みを選択して、1対1の文学的旅を始めましょう。",
  bookClubTitle: "ブッククラブ",
  bookClubDesc: "居心地の良い環境で開催される対面式またはオンラインのブッククラブに参加しましょう。各グループはAmbassadorが進行し、活気があり包括的な体験を保証します。",
  silentReadingTitle: "Silent Reading",
  silentReadingDesc: "平和なサイレントリーディングセッションをお楽しみください。お気に入りの本を持参し、リラックスして、一緒に読書する静かな喜びを共有しましょう。",
  exploreThe: "既存の",
  existingEvents: "イベントを探索",
  or: "または",
  createYourOwn: "自分で作成",
  joinOfellio: "Ofellioに参加",
  signUp: "サインアップ",
  chooseYourCountry: "国を選択",
  joined: "参加済み",
  joinedCapitalized: "参加済み",
  shareThisEvent: "このイベントを共有",
  linkVisibleAttendees: "参加者のみに表示されるリンク",
  recentReviews: "最近のレビュー",
  noReviewsAvailable: "レビューがありません",
  writeAReview: "レビューを書く",
  yourRating: "あなたの評価",
  update: "更新",
  aboutTheBook: "本について",
  makeAChoiceForThisBook: "この本の選択をしてください",
  howDidYouReadIt: "どのように読みましたか？",
  noRating: "評価なし",
  reviewPublished: "レビューが公開されました",
  useForBookDuo: "Book Duoに使用",
  yourReview: "あなたのレビュー",
  addAShortTitle: "短いタイトルを追加",
  shareYourThoughts: "この本についての感想を共有してください...",
  send: "送信",
  bookclubLive: "おめでとうございます！あなたのブッククラブは公開され、他の人が参加できるようになりました。",
  silentReadingLive: "おめでとうございます！あなたのサイレントリーディングは公開され、他の人が参加できるようになりました。",
  dashboard: "ダッシュボード",

  // Day abbreviations
  dayMon: "月",
  dayTue: "火",
  dayWed: "水",
  dayThu: "木",
  dayFri: "金",
  daySat: "土",
  daySun: "日",

  // Notification translations
  sentYouAMessage: "がメッセージを送信しました！",
  justJoinedYour: "があなたの",
};